module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "h-100"
  }, [(_vm.paieEnable) ? _c('div', {
    staticClass: "section-salarie"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('ul', {
    staticClass: "inp-nav noselect"
  }, [_c('li', {
    class: 'nav-tab ' + (_vm.tab === 1 ? 'active' : (_vm.isModified ? 'readonly' : '')),
    attrs: {
      "data-testid": "identite-field"
    },
    on: {
      "click": function($event) {
        _vm.changeTab(1)
      }
    }
  }, [_c('div', [_c('span', {
    staticClass: "far fa-address-card fa-2x"
  }), _vm._v(" "), _c('span', {
    class: 'modif ' + (_vm.isModified && _vm.tab === 1 ? 'active' : '')
  })]), _vm._v(" "), _c('div', [_vm._v("Identité")])]), _vm._v(" "), _c('li', {
    class: 'nav-tab  ' + (_vm.tab === 2 ? 'active' : (_vm.isModified ? 'readonly' : '')),
    attrs: {
      "data-testid": "declarations-field"
    },
    on: {
      "click": function($event) {
        _vm.changeTab(2)
      }
    }
  }, [_c('div', [_c('span', {
    staticClass: "fas fa-tasks fa-2x"
  }), _vm._v(" "), _c('span', {
    class: 'modif ' + (_vm.isModified && _vm.tab === 2 ? 'active' : '')
  })]), _vm._v(" "), _c('div', [_vm._v("Déclarations")])]), _vm._v(" "), _c('li', {
    class: 'nav-tab  ' + (_vm.tab === 3 ? 'active' : (_vm.isModified ? 'readonly' : '')),
    attrs: {
      "data-testid": "competences-field"
    },
    on: {
      "click": function($event) {
        _vm.changeTab(3)
      }
    }
  }, [_c('div', [_c('span', {
    staticClass: "fas fa-user-graduate fa-2x"
  }), _vm._v(" "), _c('span', {
    class: 'modif ' + (_vm.isModified && _vm.tab === 3 ? 'active' : '')
  })]), _vm._v(" "), _c('div', [_vm._v("Compétences")])]), _vm._v(" "), _c('li', {
    class: 'nav-tab  ' + (_vm.tab === 4 ? 'active' : (_vm.isModified ? 'readonly' : '')),
    attrs: {
      "data-testid": "qualifications-field"
    },
    on: {
      "click": function($event) {
        _vm.changeTab(4)
      }
    }
  }, [_c('div', [_c('span', {
    staticClass: "fas fa-id-card-alt fa-2x"
  }), _vm._v(" "), (_vm.showHorairesTabAlerte) ? _c('span', {
    staticClass: "ri-alert-line horaires-tab-alerte"
  }) : _vm._e(), _vm._v(" "), _c('span', {
    class: 'modif ' + (_vm.isModified && _vm.tab === 4 ? 'active' : '')
  })]), _vm._v(" "), _c('div', [_vm._v("Qualifications")])]), _vm._v(" "), _c('li', {
    class: 'nav-tab ' + (_vm.tab === 5 ? 'active' : (_vm.isModified ? 'readonly' : '')),
    attrs: {
      "data-testid": "contrats-field"
    },
    on: {
      "click": function($event) {
        _vm.changeTab(5)
      }
    }
  }, [_c('div', [_c('span', {
    staticClass: "fas fas fa-file-contract fa-2x"
  }), _vm._v(" "), _c('span', {
    class: 'modif ' + (_vm.isModified && _vm.tab === 5 ? 'active' : '')
  })]), _vm._v(" "), _c('div', [_vm._v("Contrats")])]), _vm._v(" "), _c('li', {
    class: 'nav-tab ' + (_vm.tab === 6 ? 'active' : (_vm.isModified ? 'readonly' : '')),
    attrs: {
      "data-testid": "reglement-field"
    },
    on: {
      "click": function($event) {
        _vm.changeTab(6)
      }
    }
  }, [_c('div', [_c('span', {
    staticClass: "far fa-credit-card fa-2x"
  }), _vm._v(" "), _c('span', {
    class: 'modif ' + (_vm.isModified && _vm.tab === 6 ? 'active' : '')
  })]), _vm._v(" "), _c('div', [_vm._v("Règlement")])]), _vm._v(" "), _c('li', {
    class: 'nav-tab ' + (_vm.tab === 7 ? 'active' : (_vm.isModified ? 'readonly' : '')),
    attrs: {
      "data-testid": "bulletins-field"
    },
    on: {
      "click": function($event) {
        _vm.changeTab(7)
      }
    }
  }, [_c('div', [_c('span', {
    staticClass: "fas fa-file-invoice-dollar fa-2x"
  }), _vm._v(" "), _c('span', {
    class: 'modif ' + (_vm.isModified && _vm.tab === 7 ? 'active' : '')
  })]), _vm._v(" "), _c('div', [_vm._v("Bulletins")])]), _vm._v(" "), _c('li', {
    class: 'nav-tab ' + (_vm.tab === 8 ? 'active' : (_vm.isModified ? 'readonly' : '')),
    attrs: {
      "data-testid": "absences-field"
    },
    on: {
      "click": function($event) {
        _vm.changeTab(8)
      }
    }
  }, [_c('div', [_c('span', {
    staticClass: "fas fa-calendar-week fa-2x"
  }), _vm._v(" "), _c('span', {
    class: 'modif ' + (_vm.isModified && _vm.tab === 8 ? 'active' : '')
  })]), _vm._v(" "), _c('div', [_vm._v("Absences")])]), _vm._v(" "), _c('li', {
    class: 'nav-tab ' + (_vm.tab === 9 ? 'active' : (_vm.isModified ? 'readonly' : '')),
    attrs: {
      "data-testid": "documents-field"
    },
    on: {
      "click": function($event) {
        _vm.changeTab(9)
      }
    }
  }, [_c('div', [_c('span', {
    staticClass: "fas fa-file fa-2x"
  }), _vm._v(" "), _c('span', {
    class: 'modif ' + (_vm.isModified && _vm.tab === 9 ? 'active' : '')
  })]), _vm._v(" "), _c('div', [_vm._v("Documents")])]), _vm._v(" "), _c('li', {
    class: 'nav-tab ' + (_vm.tab === 10 ? 'active' : (_vm.isModified ? 'readonly' : '')),
    attrs: {
      "data-testid": "bloc-notes-field"
    },
    on: {
      "click": function($event) {
        _vm.changeTab(10)
      }
    }
  }, [_c('div', [_vm._m(0), _vm._v(" "), _c('span', {
    class: 'modif ' + (_vm.isModified && _vm.tab === 10 ? 'active' : '')
  }), _vm._v(" "), _c('span', {
    staticClass: "counter"
  }, [_vm._v(_vm._s(_vm.counterNotes))])]), _vm._v(" "), _c('div', [_vm._v("Bloc-notes")])])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('common-salarie-component', {
    attrs: {
      "tab": _vm.tab,
      "salarieCharges": _vm.salarieCharges
    },
    on: {
      "goToProfil": function($event) {
        _vm.changeTab(1)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "tab-content"
  }, [_c('identite-salarie-component', {
    class: 'nav-item ' + (_vm.tab === 1 ? 'active' : ''),
    on: {
      "identiteUpdated": _vm.identiteUpdated,
      "isModified": _vm.onCurentTabModifier
    }
  }), _vm._v(" "), _c('declarations-salarie-component', {
    class: 'nav-item ' + (_vm.tab === 2 ? 'active' : ''),
    on: {
      "isModified": _vm.onCurentTabModifier
    }
  }), _vm._v(" "), _c('competences-salarie-component', {
    class: 'nav-item ' + (_vm.tab === 3 ? 'active' : ''),
    on: {
      "counterNotes": _vm.onCounterChanged,
      "isModified": _vm.onCurentTabModifier
    }
  }), _vm._v(" "), _c('qualifications-salarie-component', {
    class: 'nav-item ' + (_vm.tab === 4 ? 'active' : ''),
    on: {
      "qualificationUpdated": _vm.qualificationUpdated,
      "listeDocumentsModifiee": _vm.onActualiseListeDocuments,
      "isModified": _vm.onCurentTabModifier,
      "horairesAlerteChanged": _vm.onHorairesAlerteChanged,
      "refreshAbsences": _vm.refreshAbsences
    }
  }), _vm._v(" "), _c('contrat-salarie-component', {
    class: 'nav-item ' + (_vm.tab === 5 ? 'active' : ''),
    on: {
      "contratUpdated": _vm.contratUpdated,
      "contratHistoriqueUpdated": _vm.contratHistoriqueUpdated,
      "isModified": _vm.onCurentTabModifier
    }
  }), _vm._v(" "), _c('reglement-salarie-component', {
    class: 'nav-item ' + (_vm.tab === 6 ? 'active' : ''),
    on: {
      "isModified": _vm.onCurentTabModifier
    }
  }), _vm._v(" "), _c('bulletins-salarie-component', {
    class: 'nav-item ' + (_vm.tab === 7 ? 'active' : ''),
    on: {
      "isModified": _vm.onCurentTabModifier
    }
  }), _vm._v(" "), _c('absences-salarie-component', {
    class: 'nav-item ' + (_vm.tab === 8 ? 'active' : ''),
    on: {
      "isModified": _vm.onCurentTabModifier
    }
  }), _vm._v(" "), _c('documents-salarie-component', {
    class: 'nav-item ' + (_vm.tab === 9 ? 'active' : ''),
    on: {
      "isModified": _vm.onCurentTabModifier
    }
  }), _vm._v(" "), _c('blocnote-salarie-component', {
    class: 'nav-item ' + (_vm.tab === 10 ? 'active' : ''),
    on: {
      "counterNotes": _vm.onCounterChanged,
      "isModified": _vm.onCurentTabModifier
    }
  })], 1)])])]) : _c('div', {
    staticClass: "section-salarie"
  }, [_c('salarie-light-component')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "fas fa-sticky-note fa-2x"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8600425e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ficheSalarie/salarie.vue.html
// module id = vdGU
// module chunks = 2